import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { CoreWidgetsModule } from '../../../widgets/core.widgets.module';
import { CoreFiltersModule } from '../../../core/core.filters.module';
import { TrackerLibModule } from '../lib/tracker.lib.module';

import { TrackerAdminComponent } from './tracker.admin.component';
import { TrackerAdminMainComponent } from './tabs/mainTab/admin.main.component';
import { TrackerAddComponent } from './trackerAdd/tracker.add.component';
import { TrackerAdminAlertsAssigneeComponent } from './tabs/alertsTab/admin.alerts.assignee.component';
import { TrackerAdminAlertsSubmitterComponent } from './tabs/alertsTab/admin.alerts.submitter.component';
import { TrackerAdminCommitActionsComponent } from './tabs/commitActionsTab/admin.commit.actions.component';
import { TrackerAdminNotificationsComponent } from './tabs/notificationsTab/admin.notifications.component';
import { TrackerExtraFieldDeleteComponent } from './trackerFields/trackerExtraFieldDeleteModal/tracker.extra.field.delete.modal.controller';
import { TrackerExtraFieldEditComponent } from './trackerFields/trackerExtraFieldEditModal/tracker.extra.field.edit.modal.component';
import { TrackerAdminFieldsComponent } from './trackerFields/tracker.fields.component';
import { TrackerAdminWorkflowTransitionTabActionComponent } from './trackerWorkflow/trackerWorkflowTransitionModal/tabs/trackerWorkflowTransitionTabAction/tracker.workflow.transition.tab.action.component';
import { TrackerAdminWorkflowTransitionTabMainComponent } from './trackerWorkflow/trackerWorkflowTransitionModal/tabs/trackerWorkflowTransitionTabMain/tracker.workflow.transition.tab.main.component';
import { TrackerAdminWorkflowTransitionTabMessageComponent } from './trackerWorkflow/trackerWorkflowTransitionModal/tabs/trackerWorkflowTransitionTabMessage/tracker.workflow.transition.tab.message.component';
import { TrackerAdminWorkflowTransitionTabScriptsComponent } from './trackerWorkflow/trackerWorkflowTransitionModal/tabs/trackerWorkflowTransitionTabScripts/tracker.workflow.transition.tab.scripts.component';
import { TrackerAdminWorkflowTransitionTabAiComponent } from './trackerWorkflow/trackerWorkflowTransitionModal/tabs/trackerWorkflowTransitionTabAi/tracker.workflow.transition.tab.ai.component';
import { TrackerAdminWorkflowTransitionModalComponent } from './trackerWorkflow/trackerWorkflowTransitionModal/tracker.workflow.transition.modal.component';
import { TrackerAdminWorkflowComponent } from './trackerWorkflow/tracker.workflow.component';
import { TrackerQueryEditComponent } from './trackerQueries/trackerQueryEdit/tracker.query.edit.component';
import { TrackerQueryEditDatesComponent } from './trackerQueries/trackerQueryEdit/tabs/trackerQueryEditDates/tracker.query.edit.dates.component';
import { TrackerQueryEditFiltersComponent } from './trackerQueries/trackerQueryEdit/tabs/trackerQueryEditFilters/tracker.query.edit.filters.component';
import { TrackerQueryEditMainComponent } from './trackerQueries/trackerQueryEdit/tabs/trackerQueryEditMain/tracker.query.edit.main.component';
import { TrackerQueryDeleteComponent } from './trackerQueries/trackerQueryDelete/tracker.query.delete.component';
import { TrackerQueryListComponent } from './trackerQueries/trackerQueryList/tracker.query.list.component';
import { TrackerQueryListPagingComponent } from './trackerQueries/trackerQueryList/trackerQueryListPaging/tracker.query.list.paging.component';
import { TrackerDeleteComponent } from './trackerDeleteModal/tracker.delete.modal.component'

@NgModule({
    imports: [
      CommonModule,
      FormsModule,
      TrackerLibModule,
      CoreWidgetsModule,
      CoreFiltersModule,
    ],
    exports: [
    ],
    declarations: [
      TrackerAddComponent,
      TrackerAdminAlertsAssigneeComponent,
      TrackerAdminAlertsSubmitterComponent,
      TrackerAdminCommitActionsComponent,
      TrackerAdminNotificationsComponent,
      TrackerExtraFieldDeleteComponent,
      TrackerExtraFieldEditComponent,
      TrackerAdminFieldsComponent,
      TrackerAdminWorkflowTransitionTabActionComponent,
      TrackerAdminWorkflowTransitionTabMainComponent,
      TrackerAdminWorkflowTransitionTabMessageComponent,
      TrackerAdminWorkflowTransitionTabScriptsComponent,
      TrackerAdminWorkflowTransitionTabAiComponent,
      TrackerAdminWorkflowTransitionModalComponent,
      TrackerAdminWorkflowComponent,
      TrackerQueryEditComponent,
      TrackerQueryEditDatesComponent,
      TrackerQueryEditFiltersComponent,
      TrackerQueryEditMainComponent,
      TrackerQueryDeleteComponent,
      TrackerQueryListComponent,
      TrackerQueryListPagingComponent,
      TrackerAdminMainComponent,
      TrackerAdminComponent,
      TrackerDeleteComponent
	  ],
    providers: [
    ]
})
export class TrackerAdminModule {
    constructor() { }
}
